'use strict';
const attr = require('../dom/attr'),
	css = require('../dom/css'),
	nodeKey = require('@mindmup/mapjs-core/src/util/node-key');
module.exports = function createNode(node, parent) {
	const result = document.createElement('div');
	attr(result, {'id': nodeKey(node.id), 'tabindex': 0, 'data-mapjs-role': 'node', class: 'mapjs-node' });
	css(result, {
		display: 'block',
		opacity: 0,
		position: 'absolute',
		top: Math.round(node.y || 0) + 'px',
		left: Math.round(node.x || 0) + 'px'
	});
	parent.appendChild(result);
	return result;
};
